import React from 'react';
import { IconType } from 'react-icons/lib/esm';
import * as FontAwesome from 'react-icons/fa';
import * as MaterialDesign from 'react-icons/md';
import * as Feather from 'react-icons/fi';
import * as Ionicons5 from 'react-icons/io5';
import * as SimpleIcons from 'react-icons/si';
import { Icon } from '@chakra-ui/react';

type IconData = {
	iconName: string;
}
interface IconParams {
	nameIcon: string;
}

const IconSidebar: React.FC<IconParams> = (({ nameIcon }) => {
	const AuxIcon = ({ iconName }: IconData) => {
		const lib = iconName.slice(0, 2);

		let icon;

		if (lib === 'Fa') {
			icon = (FontAwesome as Record<string, IconType | undefined>)[iconName];
		} else if (lib === 'Md') {
			icon = (MaterialDesign as Record<string, IconType | undefined>)[iconName];
		} else if (lib === 'Fi') {
			icon = (Feather as Record<string, IconType | undefined>)[iconName];
		} else if (lib === 'Io') {
			icon = (Ionicons5 as Record<string, IconType | undefined>)[iconName];
		} else if (lib === 'Si') {
			icon = (SimpleIcons as Record<string, IconType | undefined>)[iconName];
		}

		return <Icon as={icon} />;
		// return <>{icon}</>
	}

	return <AuxIcon iconName={nameIcon} />
});

export default IconSidebar;